<template>
    <ModalConfirm
        id="modal-confirm-approve-ec-kas-kecil"
        title="Konfirmasi Setujui EC"
        desc="Apakah Anda yakin data EC kas kecil ini sudah benar?"
        :isSubmitting="isSubmitting"
        alertVariant="danger"
        alertMessage="<i class='fa fa-exclamation-triangle mr-2'></i><strong>Perhatian:</strong> Menyetujui EC akan <strong>menutup Kas Kecil ini</strong>. Aksi ini tidak dapat dibatalkan setelah disetujui."
        @submit="$emit('submit')"
    />
</template>

<script>
export default {
    name: "modal-kas-kecil-approve-ec",
    props: {
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>
